module.exports = __webpack_public_path__ + "img/dress9.cb5f57c3.jpeg";